<template>
    <div class="enterprise-email">
        <el-tabs v-model="activeName" type="border-card">
            <el-tab-pane :label="$lange == 'en' ? 'Email' : '售前邮箱配置'" name="email">
                <div style="padding: 20px;">
                    <div class="flex-between input-box">
                        <p>{{ $lange == 'en' ? 'Email' : '售前咨询指定邮箱配置'}}: </p>
                        <div>
                            <template v-if="isEdit">
                                <el-input v-model="mailData.mailbox" size="mini" :placeholder="$lange == 'en' ? 'Please Input' : '请输入'"></el-input>
                            </template>
                            <template v-else>
                                {{mailData.mailbox}}
                            </template>
                        </div>
                    </div>
                    <div class="flex-between input-box">
                        <p> {{ $lange == 'en' ? 'Authorization code' : '邮箱授权码'}}: </p>
                        <div>
                            <template v-if="isEdit">
                                <el-input v-model="mailData.password" size="mini" :placeholder="$lange == 'en' ? 'Please Input' : '请输入'"></el-input>
                            </template>
                            <template v-else>
                                {{mailData.password}}
                            </template>
                        </div>
                    </div>
                    <div class="btn-group">

                        <template v-if="isEdit">
                            <el-button  size="mini" @click="cancelEdit">{{ $lange == 'en' ? 'Cancel' : '取消'}}</el-button>
                            <el-button type="primary" size="mini" @click="save">{{ $lange == 'en' ? 'Save' : '保存'}}</el-button>
                        </template>
                        <template v-else>
                            <el-button type="primary" size="mini" @click="isEdit = true">{{ $lange == 'en' ? 'Edit' : '编辑'}}</el-button>
                        </template>
                    </div>
                </div>

            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    export default {
        name: "EnterpriseEmail",
        data() {
            return {
                activeName: "email",
                isEdit: false,
                mailData: {
                    mailbox: "",
                    password: ""
                }
            }
        },
        methods: {
            cancelEdit(){
                this.isEdit = false;
                this.getData()
            },
            save(){
                let checkEmail = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/;
                let data = this.mailData;

                console.log(checkEmail.test(data.mailbox))
                if(!checkEmail.test(data.mailbox)){
                    return this.$message({
                        type: "warning",
                        message: "请输入正确的邮箱地址, 以免发送邮件失败"
                    })
                }
                this.ccRequest.do("admin/fsb/mailbox/config/save", data, "POSTJSON").then(res => {
                    this.$message({
                        type: "success",
                        message: "保存成功"
                    })
                    this.isEdit = false;
                })

            },
            getData(){
                this.ccRequest.do("admin/fsb/mailbox/config/query", {}, "GET").then(res => {
                    if(res.rows != ''){
                        this.mailData = res.rows[0];
                    } else {
                        this.mailData = {
                            mailbox: "",
                            password: ""
                        };
                    }
                })
            }
        },
        mounted() {
            this.getData();
        }
    }
</script>

<style scoped lang="scss">
    .enterprise-email{

        .input-box{
            margin-bottom: 20px;
            justify-content: flex-start;
            p{
                min-width: 150px;
                text-align: right;
                margin-right: 10px;
            }
        }
        .btn-group{
            width: 338px;
            text-align: right;
        }
    }
</style>
